module.exports = __webpack_public_path__ + "static/media/17.625d9dfd.jpeg";